export default {
  name: "add_day",
  box: 24,
  svg: `<path d="M8 13.3333V7.99999M8 7.99999V2.66666M8 7.99999H13.3333M8 7.99999H2.66667" stroke="#894A00" stroke-linecap="round"/>`,
};
